import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import api from "/src/api"
import ElementUI from 'element-ui';
import dataV from '@jiaminghi/data-view';

import "@/utils/rem"
import '@/style/style.less'
import '@/assets/font/iconfont.css'
import '@/style/element-variables.scss'
import "@/icons/index"; // icon
// import "@/permission"
import "@/utils/direactive" // 自定义指令
import "@/components" // 自定义组件
import "@/mixin/mixin"
import tool from "@/utils"
import watermark from './utils/watermark.js'


// Vue.prototype.$watermark = watermark

Vue.use(ElementUI);
Vue.use(dataV);
Vue.prototype.$api = api
Vue.prototype.$tool = tool
Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
